<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn>
      </v-card-text>

      <!-- <v-card-text class="white--text pt-0">
        How long are you going to wait before you demand the best for yourself?
      </v-card-text> -->

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>CaselLab Solutions</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-email",
        link: "mailto:lillian@fisioviajante.com.br",
      },
      {
        text: "mdi-whatsapp",
        link: "http://wa.me/5511964285722?text=Ol%C3%A1,%20quero%20viajar%20melhor%20e%20gostaria%20de%20saber%20mais%20informa%C3%A7%C3%B5es",
      },
      {
        text: "mdi-linkedin",
        link: "https://www.linkedin.com/in/lillian-holovatino-161a2025/",
      },
      {
        text: "mdi-instagram",
        link: "https://instagram.com/fisioviajante/",
      },
    ],
  }),
};
</script>
